import { Prescription } from "./Prescription";
import { Program } from "./Program";
import { Store } from "./Store";
import { Team } from "./Team";

export interface CustomTextMessageTemplate {
    id: number;
    name: string;
    active: boolean;
    requiresPrescription: boolean;
    template: string;
    teams: Team[];
    limitToPrograms: Program[];

    relatedPrescription?: Prescription;
    store?: Store;
}

export class CustomTextMessageTemplate
{

}

export interface DefaultTemplates {
    [key: string]: { template: string };
}


export interface TemplateValue {
    active?: boolean;
    disabled?: boolean;
    template?: string;
}

export interface TemplateDefinition {
    label: string;
    key: string;
    tokens: string[];
    preview?: string;
    helpText?: string;
}
